import { EntityState } from '@ngrx/entity';
import { AccountFilter } from '../models/account.filter';
import { Account } from '../models/account';
import { KycDocument } from '../models/document';
import { BankAccount } from '../models/bank-account';

export const accountFeatureKey = 'accounts';

export interface AccountState extends EntityState<Account> {
  kycDocuments: KycDocument[];
  bankAccounts: BankAccount[];
  error: any;
  totalCount: number;
  filter: AccountFilter;
  current: Account[];
}
